var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('accountsWithdrawals.accountWithdrawals'),"description":_vm.$t('accountsWithdrawals.fromHereYouCanControlAccountWithdrawals')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('accountsWithdrawals.SearchForAnOperation'),"emptyTableText":_vm.$t('accountsWithdrawals.thereAreNoWithdrawalsOperations'),"buttonRole":_vm.$user.role.accounts_withdrawals_add,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"statusSearch":true,"statusValues":[
          { title: _vm.$t('orders.situation'), value: ''},
          { title: _vm.$t('orders.all'), value: ''},
          { title: _vm.$t('invoices.draft'), value: 0 },
          { title: _vm.$t('invoices.approved'), value: 1 } ],"cloumns":[
          { column: 'code', title: _vm.$t('accountsWithdrawals.Process'), type: 'mainLink', sort: true },
          {
            column: 'account_id',
            title: _vm.$t('accountsWithdrawals.accountName'),
            type: 'link',
            to: 'account',
            sort: true,
            link: true,
          },
          {
            column: 'safe_id',
            title: _vm.$t('accountsWithdrawals.Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true,
          },
          { column: 'date', title: _vm.$t('accountsWithdrawals.date'), type: 'text', sort: true },
          {
            column: 'description',
            title: _vm.$t('accountsWithdrawals.AndThatIsAbout'),
            type: 'text',
            sort: true,
          },
          {
            column: 'cost',
            title: _vm.$t('accountsWithdrawals.cost'),
            type: 'text',
            sort: true
          },
          {column: 'status', title: _vm.$t('bills.situation') ,type: 'status' , sort: true ,  values: [
                {title: _vm.$t('invoices.draft'), value: 0, color: 'dark'},
                {title: _vm.$t('invoices.approved'), value: 1, color: 'success'} ]
          },
          {
            column: 'options',
            title: _vm.$t('accountsWithdrawals.actions'),
            type: 'options',
            options: [
              { name: 'show' },
              {name: 'printAccountsWithdrawal',   role: true},
              {
                name: 'edit',
                role:
                  _vm.$user.admin ||
                  _vm.$user.role.accounts_withdrawals_edit,
              },
              {name: 'file'},
              { name: 'printPurchasePayment', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role:
                  _vm.$user.admin ||
                  _vm.$user.role.accounts_withdrawals_delete,
              } ],
          } ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem:
            _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading'),
        }}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }